import { NgForm } from '@angular/forms';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ChatApiService } from 'src/app/core/services/api/chat-api.service';
import { UsersApiService } from 'src/app/core/services/api/users-api.service';
import { ChatService } from 'src/app/core/services/chat.service';
import { Chat } from 'src/app/shared/models/chat/chat';
import { NgSelectProps } from 'src/app/shared/models/ng-select-props';
import { SearchParams } from 'src/app/shared/models/searchParams';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit {

  public chats: Chat[] = [];
  chatCount = 0;
  public searchParams: SearchParams = new SearchParams();

  @ViewChild('chatModal') chatModal;
  modalRef: NgbModalRef;

  @ViewChild('chatListItems') chatListItems: ElementRef<HTMLElement>;

  userNgSelect: NgSelectProps = null;
  newChat: Chat = new Chat();
  page = 1;

  constructor(
    private chatApi: ChatApiService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private bsModalService: NgbModal,
    private userApi: UsersApiService,
    private router: Router,
    private chatService: ChatService,
    public authService: AuthService
  ) { }

  ngOnInit(): void {
    this.chatService.loadChats(this.searchParams);
    this.userNgSelect = new NgSelectProps(this.userApi.getStaffUsers);
    this.chatService.chats$.subscribe(r => {
      this.chats = [...r];
      this.chatCount = this.chatService.chatCount;
    }
    );
  }

  onSearch(e: KeyboardEvent) {
    this.chatService.chatList = [];
    if (e.keyCode === 13) {
      this.searchParams.page = 1;
      this.searchParams.search = (e.target as HTMLInputElement).value;
      this.chatService.loadChats(this.searchParams);
    }
  }

  openChatModal() {
    this.modalRef = this.bsModalService.open(this.chatModal, {
      size: 'md',
      centered: true,
      beforeDismiss: this.beforeChatModalClose
    });
  }

  beforeChatModalClose = (): boolean => {
    this.newChat = new Chat();
    return true;
  };

  closeModal() {
    this.modalRef.close();
  }

  createNewChat(f: NgForm) {
    this.spinner.show();
    this.chatApi.createChat(this.newChat).subscribe(
      r => {
        this.chats.unshift(r);
        this.modalRef.close();
        // this.toastr.success('Chat created', 'Success');
        this.router.navigate(['/chat', r.uuid]);
        f.resetForm();
        this.spinner.hide();
      }
    )
  }

  selectChat(chat: Chat) {
    this.chatService.activeChat$.next(Object.assign(new Chat(), chat));
    // this.chatService.loadChats(this.searchParams);
  }

  chatScroll(e) {
    const chatListEle = this.chatListItems.nativeElement;
    if (chatListEle.scrollTop + chatListEle.offsetHeight > chatListEle.scrollHeight - 150 && this.page < this.chatCount / 10) {
      this.page++;
      this.searchParams.page = this.page;
      this.chatService.loadChats(this.searchParams);
    }
  }
}
